import type {PS, MobileAlgoConditionType as MobileAlgoConditionTypeType} from '@wix/document-services-types'
import {MobileAlgoConditionType} from '../../../constants/constants'
import type {MobileAlgoExtensionApi} from '@wix/document-manager-extensions/src/extensions/mobileAlgo/mobileAlgo'
import type {EnvironmentExtensionAPI} from '@wix/document-manager-extensions'
import {getReportableFromError, ReportableError} from '@wix/document-manager-utils'
import _ from 'lodash'

export const runResponsiveMobileForAllPages = async (
    ps: PS,
    conditionType: MobileAlgoConditionTypeType = MobileAlgoConditionType.RevisionSave
) => {
    const isEditor3 = (ps.extensionAPI as EnvironmentExtensionAPI).environment.isEditor3()
    if (isEditor3) {
        try {
            const {mobileAlgo} = ps.extensionAPI as MobileAlgoExtensionApi
            await mobileAlgo.runForAllPages({conditionType})
        } catch (e: any) {
            const newError =
                e instanceof ReportableError
                    ? e
                    : getReportableFromError(e, {
                          errorType: 'ResponsifyAlgorithmError'
                      })

            if (newError.errorType !== 'GroupingModelNetworkError') {
                _.set(newError, 'tags.shouldRestoreRevision', true)
            }

            throw newError
        }
    }
}

export const softLockSections = async (ps: PS) => {
    const isEditor3 = (ps.extensionAPI as EnvironmentExtensionAPI).environment.isEditor3()
    if (isEditor3) {
        const {mobileAlgo} = ps.extensionAPI as MobileAlgoExtensionApi
        mobileAlgo.locking.unlockSectionsForAllPages()
        await mobileAlgo.locking.softLockAllPages()
        mobileAlgo.locking.lockSectionsForAllPages()
    }
}
